import OrderManagement from './OrderManagement'

const OrderManagementContainer = () => {
  return <OrderManagement/>
}

export default OrderManagementContainer
